import { render, staticRenderFns } from "./AnnotationElementPlayerComponent.vue?vue&type=template&id=934d1af2&scoped=true"
import script from "./AnnotationElementPlayerComponent.vue?vue&type=script&lang=ts"
export * from "./AnnotationElementPlayerComponent.vue?vue&type=script&lang=ts"
import style0 from "./AnnotationElementPlayerComponent.vue?vue&type=style&index=0&id=934d1af2&prod&scoped=true&lang=scss"
import style1 from "./AnnotationElementPlayerComponent.vue?vue&type=style&index=1&id=934d1af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934d1af2",
  null
  
)

export default component.exports